<template>
  <header>
    <div
      id="nav"
      :class="lightBackground && scroll > 100 ? 'light-bg' : !lightBackground && scroll > 100 ? 'dark-bg' : ''"
    >
      <div class="half">
        <a @click.prevent="redirect('/')" class="logo">
          <svg v-if="!smallScreen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1023.46 287.03">
            <path
              class="cls-1"
              d="M254.57,354.08q-9.44-6.88-30.61-8.65l-42.76-3.3q-7.39-.58-10.51-2.33a5.68,5.68,0,0,1-3.11-5.25q0-8.35,25.07-8.35,35.17,0,54.23,13.4l15-17.68Q239.1,304.43,196,304.43q-62.79,0-62.78,32.07,0,13.39,10,20.69t31.19,9.24l42,3.5q7.38.58,10.2,2.33a5.92,5.92,0,0,1,2.81,5.44q0,4.88-5.63,7t-18.66,2.14q-41.21,0-60.83-17.89l-18.08,17.11Q150.09,409,201.59,409,264,409,264,374.41,264,361,254.57,354.08Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M401.32,318.72q-20.61-14.28-54.81-14.28-34,0-54.62,14.28t-20.6,38q0,23.71,20.6,38T346.51,409q34.2,0,54.81-14.29t20.6-38Q421.92,333,401.32,318.72Zm-28.38,58.7q-9.92,7.68-26.43,7.68-16.33,0-26.34-7.78a26.2,26.2,0,0,1,0-41.2q10-7.77,26.34-7.77,16.51,0,26.43,7.67t9.91,20.7q0,13-9.91,20.69Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M480.59,314.05a41,41,0,0,0-15.84,22.83V308.12H431.9V405.3h37.54V373.81q0-18.46,10.3-28,8.94-8.94,26.62-8.94a86.5,86.5,0,0,1,15.56,1.56V306.56a91.91,91.91,0,0,0-12.84-1Q492.34,305.59,480.59,314.05Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M598.27,272.18,560.76,285.4v22.72H532v23.52h28.77V367q0,41,51.5,41,19.83,0,29.74-4.47V377.31a79.56,79.56,0,0,1-20,2.53q-23.72,0-23.71-20V331.64H642V308.11H598.27Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M739.29,304.21q-17.31,0-30.42,6.42a44,44,0,0,0-19.73,18.26v-64.5H651.63V405.3h37.51V364.68q0-16.14,9.23-25.08t25.56-8.94q33,0,33,35V405.3h37.51V361.57q0-27.6-14.38-42.47T739.29,304.21Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M870.9,365.65a121.78,121.78,0,0,0-5.24,11.08h-1a119.09,119.09,0,0,0-5.23-11.08l-31.09-57.53h-41l56.55,97.18h42.54L943,308.12H902Z"
              transform="translate(-126.18 -264)"
            />
            <rect class="cls-1" x="826.64" y="44.12" width="37.51" height="97.18" />
            <rect class="cls-1" x="825.48" width="39.65" height="29.74" />
            <path
              class="cls-1"
              d="M1112.05,264.39V322.5q-17.1-18.08-49.36-18.07-28,0-45.29,14.28t-17.29,37.41q0,23.52,17,38.2t44,14.67q35.37,0,51.9-22.74V405.3h36.53V264.39Zm.78,93.29q0,12.06-10.59,19.63t-26.92,7.58q-16.52,0-26.33-7.68t-9.82-20.89q0-13,9.43-20.61t25.94-7.57q16.92,0,27.6,7.57t10.69,19.64Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M578.08,549.56a23.17,23.17,0,0,0,2.5-.37.89.89,0,0,0,.78-.92V498a25.17,25.17,0,0,0-.13-3,4.89,4.89,0,0,0-.5-1.79,2.34,2.34,0,0,0-1-1,6.42,6.42,0,0,0-1.65-.5l-3-.45.09-.92,12.51-3.13-.08,7.73.27.18a28.23,28.23,0,0,1,6.16-5.38,14.33,14.33,0,0,1,7.92-2.25,15.18,15.18,0,0,1,6.53,1.42,15.4,15.4,0,0,1,5.25,4,18.72,18.72,0,0,1,3.45,6.16,25.44,25.44,0,0,1-.45,17,22,22,0,0,1-4.56,7,21,21,0,0,1-6.53,4.5,18.55,18.55,0,0,1-7.55,1.61,22.89,22.89,0,0,1-5.71-.69,25.87,25.87,0,0,1-4.6-1.61h-.18v21.52c0,.31.21.54.64.69a15.8,15.8,0,0,0,3.13.41l4,.1.27,1.38H575.31l.28-1.38ZM604.26,526a11.91,11.91,0,0,0,3.82-3.82,20.13,20.13,0,0,0,2.44-5.75,28.71,28.71,0,0,0,.88-7.27,24.17,24.17,0,0,0-.93-6.81,17.7,17.7,0,0,0-2.57-5.43,12.35,12.35,0,0,0-4-3.63A10.76,10.76,0,0,0,598.5,492a11.71,11.71,0,0,0-6.16,1.61,21,21,0,0,0-4.69,3.82V520.3a18.24,18.24,0,0,0,4.83,5,11.26,11.26,0,0,0,6.67,2.12A9.58,9.58,0,0,0,604.26,526Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M647,527.34a7.54,7.54,0,0,1-1.8-4.93l-.18-.09A35.29,35.29,0,0,1,639.5,527a11,11,0,0,1-10.12,1.29,9.36,9.36,0,0,1-3.09-1.93,9.88,9.88,0,0,1-2.07-3,8.58,8.58,0,0,1-.77-3.63,9.47,9.47,0,0,1,1.1-4.55,11.48,11.48,0,0,1,3.69-3.87,32,32,0,0,1,6.85-3.41,99.73,99.73,0,0,1,10.62-3.17l.1-3.13a18.84,18.84,0,0,0-.6-5.79,9.76,9.76,0,0,0-1.93-3.69,6.84,6.84,0,0,0-2.94-1.93,11.88,11.88,0,0,0-3.65-.55,10.73,10.73,0,0,0-2.76.37,16.19,16.19,0,0,0-2.43.83,7.22,7.22,0,0,0-1.75,1c-.46.36-.69.68-.69.92a1.06,1.06,0,0,0,.32.64c.21.25.46.56.74.93a6.23,6.23,0,0,1,.73,1.28,3.87,3.87,0,0,1,.32,1.57,3.52,3.52,0,0,1-1.1,2.57,4,4,0,0,1-3,1.11,4.42,4.42,0,0,1-2.9-1,3.22,3.22,0,0,1-1.14-2.62,5.35,5.35,0,0,1,1.7-3.5,17.69,17.69,0,0,1,4.28-3.32,28.92,28.92,0,0,1,5.66-2.43,19.19,19.19,0,0,1,11.18-.28,7.79,7.79,0,0,1,3.73,2.35,10.32,10.32,0,0,1,2.07,4.46,27.67,27.67,0,0,1,.46,7l-.91,19.61a4.21,4.21,0,0,0,.64,2.95A2.68,2.68,0,0,0,654,525a3.66,3.66,0,0,0,2.11-.78,22.53,22.53,0,0,0,2.21-1.8l.74.83c-.5.61-1,1.26-1.61,1.93a18.73,18.73,0,0,1-1.89,1.89,9.76,9.76,0,0,1-2.16,1.43A5.54,5.54,0,0,1,651,529,5.28,5.28,0,0,1,647,527.34Zm-6-3.64a20.74,20.74,0,0,0,4.18-3l.46-14.45a55.78,55.78,0,0,0-7.87,2.5,19.13,19.13,0,0,0-4.83,2.76,7.94,7.94,0,0,0-2.39,3.08,9.26,9.26,0,0,0-.64,3.45,6.59,6.59,0,0,0,1.88,5,6.47,6.47,0,0,0,4.65,1.79A9.66,9.66,0,0,0,641,523.7Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M662.93,526.46a15,15,0,0,0,2.57-.41.93.93,0,0,0,.73-1v-27a23.25,23.25,0,0,0-.14-3,5,5,0,0,0-.5-1.83,2.27,2.27,0,0,0-1-1,6.83,6.83,0,0,0-1.65-.5l-2.87-.45.1-.92,12.42-3.13-.18,14.35h.18a39.06,39.06,0,0,1,5.51-10.86,8.6,8.6,0,0,1,6.9-3.68,5.24,5.24,0,0,1,3.82,1.39,4.33,4.33,0,0,1,1.43,3.21,4.88,4.88,0,0,1-1.1,3.13,3.76,3.76,0,0,1-3.13,1.38,4.64,4.64,0,0,1-3-1.15,5.16,5.16,0,0,1-1.65-3.54,9.11,9.11,0,0,0-4.88,4.1,38.38,38.38,0,0,0-4,9.15v20.52a.81.81,0,0,0,.59.78,13.82,13.82,0,0,0,3,.42l3.78.09.27,1.38H660.25l.28-1.38Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M703.79,528.72a7.33,7.33,0,0,1-2.9-1.66,7.64,7.64,0,0,1-1.93-3,13,13,0,0,1-.7-4.51l.47-27.42-7.18-.19.28-1.56,12.32-10.31,1.11.28-.09,8.1h13.62l-1.11,3.5H705.17c-.12,5-.24,9.48-.37,13.35-.06,1.65-.11,3.3-.14,4.92s0,3,0,4.28c-.06,1.47-.1,2.85-.1,4.14a6.17,6.17,0,0,0,1.61,4.88,6.58,6.58,0,0,0,4.66,1.56,9.15,9.15,0,0,0,4.27-1,22.54,22.54,0,0,0,3.54-2.25l.55.91a41.84,41.84,0,0,1-5.47,4.47,11,11,0,0,1-6.3,2A12.43,12.43,0,0,1,703.79,528.72Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M751.08,527.61a20.22,20.22,0,0,1-6.54-4.42,19.77,19.77,0,0,1-4.27-6.62,21.94,21.94,0,0,1-1.53-8.24,21.41,21.41,0,0,1,1.62-8.32,21,21,0,0,1,4.36-6.77,21.2,21.2,0,0,1,23-4.6,19.38,19.38,0,0,1,10.68,10.86,21.86,21.86,0,0,1,1.5,8.19,22.72,22.72,0,0,1-1.56,8.51A21.57,21.57,0,0,1,774,523a20.14,20.14,0,0,1-14.72,6.21A20.6,20.6,0,0,1,751.08,527.61Zm13.71-1.42a13.37,13.37,0,0,0,4.09-4,20.58,20.58,0,0,0,2.67-5.93,26.45,26.45,0,0,0,1-7.18,37.39,37.39,0,0,0-1.2-9.71,15.7,15.7,0,0,0-3.86-7.14,14,14,0,0,0-3.59-2.57,10.34,10.34,0,0,0-4.7-1,10.21,10.21,0,0,0-5.38,1.5,13.18,13.18,0,0,0-4.14,4A20,20,0,0,0,747,500a25.49,25.49,0,0,0-.92,7,36.46,36.46,0,0,0,1.29,10.08,16,16,0,0,0,4,7.22,11,11,0,0,0,3.5,2.51,11.33,11.33,0,0,0,4.7.92,9.92,9.92,0,0,0,5.24-1.54Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M786.87,526.46a21.2,21.2,0,0,0,2.5-.36.88.88,0,0,0,.74-.93V492l-7.09-.18,1.1-3.4h5.81l.18-2.4a26.85,26.85,0,0,1,2-8.69,21.17,21.17,0,0,1,4-6.26,16.86,16.86,0,0,1,5.44-3.82,15.11,15.11,0,0,1,6-1.29,7.33,7.33,0,0,1,4.65,1.34,3.91,3.91,0,0,1,1.7,3.17,3.62,3.62,0,0,1-1.1,2.67,3.88,3.88,0,0,1-2.85,1.1,4.57,4.57,0,0,1-3.32-1.47,7.15,7.15,0,0,1-1.93-3.78l-.19-.54-1.47-.19a8.23,8.23,0,0,0-5.2,5.56,35.22,35.22,0,0,0-1.42,10.91v3.69H807.3L806.19,492h-9.75v33.22a.8.8,0,0,0,.55.79,13.49,13.49,0,0,0,3,.41l4.13.1.28,1.37H784.1l.28-1.37Z"
              transform="translate(-126.18 -264)"
            />
            <path
              class="cls-1"
              d="M1105.23,529.22h22.26V468h22.16V449.29h-66.56V468h22.15Zm-73.31-43.28V466.53h12.79c8.22,0,12.22,3.31,12.22,9.71s-4,9.7-12.22,9.7Zm-22.27,43.28h22.27v-26h13.24c20,0,33.35-8.45,33.35-26.95s-13.36-26.95-33.35-26.95h-35.53Zm-76.51,0h60.64V511.29H955.41V497.7h38V480.57h-38V467.21h38.37V449.29H933.14Zm-67.25-18.61V467.9H873c15.64,0,25.23,5.5,25.23,21.36s-9.59,21.35-25.23,21.35Zm-22.27,18.61h29.11c27.53,0,47.51-10.85,47.51-40s-20-40-47.51-40H843.62Z"
              transform="translate(-126.18 -264)"
            />
          </svg>
          <svg class="-small" v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1051.3 461.07">
            <title>Part_Of_Dept_Mobile</title>
            <path
              class="cls-1"
              d="M818.51,442.06h83.33V376.67H818.51Zm-260.23,0V358.73q0-33.09,18.94-51.43T629.63,289q67.79,0,67.79,71.78v81.33h77V352.35q0-56.61-29.51-87.1t-83.72-30.52q-35.52,0-62.41,13.15t-40.45,37.5V153h-77V442.06ZM440,378.67q0-27.51-19.34-41.67t-62.8-17.74l-87.71-6.77q-15.15-1.22-21.51-4.79a11.56,11.56,0,0,1-6.39-10.77q0-17.15,51.44-17.15,72.13,0,111.22,27.52L435.57,271Q388.91,235.1,300.4,235.1q-128.77,0-128.78,65.77,0,27.53,20.53,42.48t64,18.94l86.12,7.17c10.08.81,17.06,2.38,20.92,4.79s5.79,6.12,5.79,11.17c0,6.65-3.86,11.41-11.56,14.34s-20.48,4.38-38.28,4.38q-84.54,0-124.81-36.68l-37.06,35.09q49,47.06,154.7,47.05,128,0,128-71"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M480.36,612.19a29.36,29.36,0,0,0,3.22-.46,1.14,1.14,0,0,0,1-1.18v-64a34.58,34.58,0,0,0-.17-3.81,6.23,6.23,0,0,0-.65-2.28,2.84,2.84,0,0,0-1.29-1.23,7.86,7.86,0,0,0-2.1-.65l-3.8-.6.12-1.18,15.93-4-.11,9.85.35.24a35.46,35.46,0,0,1,7.85-6.86,18.24,18.24,0,0,1,10.08-2.87,19.08,19.08,0,0,1,8.33,1.82,19.5,19.5,0,0,1,6.68,5.09,24,24,0,0,1,4.4,7.86,32.45,32.45,0,0,1-.58,21.63,27.89,27.89,0,0,1-5.81,8.91,26.54,26.54,0,0,1-8.32,5.74,23.78,23.78,0,0,1-9.61,2.06,29.25,29.25,0,0,1-7.28-.88,33.35,33.35,0,0,1-5.86-2h-.17v27.43c0,.39.27.68.82.88a20.67,20.67,0,0,0,4,.52l5,.12.35,1.76H476.83l.35-1.76Zm33.35-30a15.37,15.37,0,0,0,4.87-4.86,25.76,25.76,0,0,0,3.1-7.33,36.18,36.18,0,0,0,1.12-9.26,31,31,0,0,0-1.18-8.67,22.46,22.46,0,0,0-3.28-6.92,15.69,15.69,0,0,0-5.16-4.63,13.71,13.71,0,0,0-6.8-1.71,14.89,14.89,0,0,0-7.85,2.05,26.31,26.31,0,0,0-6,4.87v29.19a22.77,22.77,0,0,0,6.16,6.33,14.34,14.34,0,0,0,8.49,2.7,12.13,12.13,0,0,0,6.53-1.77Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M568.1,583.88a9.55,9.55,0,0,1-2.28-6.27l-.23-.12a45,45,0,0,1-7,5.92,14.07,14.07,0,0,1-12.91,1.65,11.52,11.52,0,0,1-3.93-2.47,12.26,12.26,0,0,1-2.64-3.75,11.21,11.21,0,0,1-1-4.63,12.21,12.21,0,0,1,1.4-5.8,14.68,14.68,0,0,1,4.7-4.93,40.4,40.4,0,0,1,8.73-4.34,124.43,124.43,0,0,1,13.54-4l.12-4a24.22,24.22,0,0,0-.76-7.39,12.22,12.22,0,0,0-2.46-4.69,8.57,8.57,0,0,0-3.75-2.46,14.93,14.93,0,0,0-4.64-.71,13.45,13.45,0,0,0-3.52.47,19.88,19.88,0,0,0-3.1,1.06,9.53,9.53,0,0,0-2.23,1.29c-.58.46-.87.86-.87,1.17a1.31,1.31,0,0,0,.4.82c.27.31.59.7.94,1.17a7.87,7.87,0,0,1,.93,1.65,4.75,4.75,0,0,1,.41,2,4.51,4.51,0,0,1-1.4,3.28,5,5,0,0,1-3.75,1.41,5.63,5.63,0,0,1-3.7-1.23,4.12,4.12,0,0,1-1.46-3.34,6.76,6.76,0,0,1,2.17-4.46,22.18,22.18,0,0,1,5.46-4.22,36.17,36.17,0,0,1,7.2-3.11,24.65,24.65,0,0,1,7.33-1.23,24.21,24.21,0,0,1,6.92.88,9.88,9.88,0,0,1,4.75,3,13.11,13.11,0,0,1,2.64,5.69,35.28,35.28,0,0,1,.58,9l-1.18,25a5.47,5.47,0,0,0,.83,3.76A3.4,3.4,0,0,0,577,581a4.77,4.77,0,0,0,2.68-1,31.11,31.11,0,0,0,2.83-2.29l.93,1c-.62.79-1.31,1.61-2,2.47a23.74,23.74,0,0,1-2.41,2.4,12.87,12.87,0,0,1-2.75,1.82,7,7,0,0,1-3.1.7A6.72,6.72,0,0,1,568.1,583.88Zm-7.61-4.62a26.73,26.73,0,0,0,5.33-3.88l.58-18.4a71.22,71.22,0,0,0-10,3.16,24.25,24.25,0,0,0-6.16,3.51,10.24,10.24,0,0,0-3,3.93,11.42,11.42,0,0,0-.82,4.4,8.36,8.36,0,0,0,2.4,6.39,8.25,8.25,0,0,0,5.92,2.29A12.27,12.27,0,0,0,560.49,579.26Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M588.45,582.77a18.38,18.38,0,0,0,3.28-.53,1.21,1.21,0,0,0,.93-1.23V546.66a34.59,34.59,0,0,0-.18-3.81,6.38,6.38,0,0,0-.64-2.34,2.88,2.88,0,0,0-1.29-1.29,7.86,7.86,0,0,0-2.1-.65L584.8,538l.13-1.18,15.82-4-.23,18.3h.23q3.27-9.15,7-13.84t8.79-4.69a6.7,6.7,0,0,1,4.87,1.76,5.51,5.51,0,0,1,1.82,4.1,6.2,6.2,0,0,1-1.4,4,4.86,4.86,0,0,1-4,1.76,5.92,5.92,0,0,1-3.87-1.47,6.55,6.55,0,0,1-2.11-4.51c-2.35.7-4.41,2.44-6.21,5.21a48.18,48.18,0,0,0-5,11.67v26.14a1,1,0,0,0,.75,1,18.22,18.22,0,0,0,3.82.53l4.8.12.35,1.75H585.05l.35-1.75Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M640.5,585.64a9.31,9.31,0,0,1-3.7-2.11,9.79,9.79,0,0,1-2.46-3.81,16.48,16.48,0,0,1-.88-5.74l.59-34.94-9.15-.24.36-2L641,523.67l1.41.35-.12,10.32h17.32l-1.41,4.45H642.22q-.24,9.62-.47,17c-.07,2.11-.13,4.21-.18,6.28s0,3.89,0,5.45c-.08,1.87-.12,3.63-.12,5.27-.08,2.82.61,4.89,2,6.21a8.38,8.38,0,0,0,5.93,2,11.85,11.85,0,0,0,5.45-1.23,29.06,29.06,0,0,0,4.5-2.87l.71,1.17a54.54,54.54,0,0,1-7,5.69,14,14,0,0,1-8,2.52A15.47,15.47,0,0,1,640.5,585.64Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M700.75,584.23a25.79,25.79,0,0,1-8.33-5.62,25,25,0,0,1-5.44-8.45,28.4,28.4,0,0,1,.06-21.09,26.62,26.62,0,0,1,5.57-8.62A25.59,25.59,0,0,1,701,534.7a26.1,26.1,0,0,1,10.5-2.11,26.74,26.74,0,0,1,10.37,2,24.69,24.69,0,0,1,13.6,13.84,27.78,27.78,0,0,1,1.94,10.43,29.19,29.19,0,0,1-2,10.85,26.94,26.94,0,0,1-5.51,8.67,25.63,25.63,0,0,1-18.75,7.92A26.26,26.26,0,0,1,700.75,584.23Zm17.47-1.81a17.24,17.24,0,0,0,5.21-5.1,26.55,26.55,0,0,0,3.4-7.56,33.71,33.71,0,0,0,1.24-9.15,47.81,47.81,0,0,0-1.53-12.37,19.89,19.89,0,0,0-4.92-9.09,18.22,18.22,0,0,0-4.57-3.28,13.41,13.41,0,0,0-6-1.29,13,13,0,0,0-6.85,1.88,16.59,16.59,0,0,0-5.28,5.1,25.35,25.35,0,0,0-3.35,7.42,33.08,33.08,0,0,0-1.17,8.91A46.84,46.84,0,0,0,696,570.73a20.71,20.71,0,0,0,5,9.2,13.81,13.81,0,0,0,4.46,3.17,14.37,14.37,0,0,0,6,1.17A12.54,12.54,0,0,0,718.22,582.42Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M746.35,582.77a26.34,26.34,0,0,0,3.17-.47,1.11,1.11,0,0,0,.93-1.17V538.92l-9-.23,1.4-4.34h7.39l.23-3.05A34.35,34.35,0,0,1,753,520.22a27,27,0,0,1,5.16-8,21.25,21.25,0,0,1,6.92-4.87,19.16,19.16,0,0,1,7.68-1.64,9.29,9.29,0,0,1,5.92,1.71,5,5,0,0,1,2.17,4,4.63,4.63,0,0,1-1.41,3.4,5,5,0,0,1-3.63,1.41,5.86,5.86,0,0,1-4.23-1.88,9.07,9.07,0,0,1-2.45-4.81l-.24-.7L767,508.6c-3.2,1.09-5.4,3.47-6.62,7.09a44.47,44.47,0,0,0-1.82,13.9v4.69H772.4L771,538.85H758.57v42.32a1,1,0,0,0,.7,1,17.52,17.52,0,0,0,3.88.53l5.27.12.36,1.75H742.86l.36-1.75Z"
              transform="translate(-157.27 -152.98)"
            />
            <path
              class="cls-1"
              d="M1151.93,586.29h28.36v-78h28.28V484.45h-84.81v23.86H1152Zm-93.36-55.14V506.42h16.3c10.47,0,15.56,4.22,15.56,12.37s-5.09,12.36-15.56,12.36Zm-28.36,55.14h28.36V553.12h16.88c25.46,0,42.48-10.77,42.48-34.33s-17-34.34-42.48-34.34h-45.28Zm-97.47,0H1010V563.45H961.07V546.14h48.44V524.31H961.07v-17H1010V484.45H932.7Zm-85.68-23.72V508.16h9c19.93,0,32.14,7,32.14,27.21s-12.21,27.2-32.14,27.2Zm-28.37,23.72h37.09c35.06,0,60.53-13.82,60.53-50.92s-25.47-50.92-60.53-50.92H818.69Z"
              transform="translate(-157.27 -152.98)"
            />
          </svg>
        </a>
      </div>

      <div class="half" :class="hideMenu ? 'hidden' : ''">
        <!-- <div class="mobile-menu">
				<button class="mobile-menu-toggle" type="button" name="mobile-menu-toggle" @click="toggleMobileMenu">menu</button>
        </div>-->

        <!-- Desktop Menu -->
        <div class="menu-links">
          <router-link to="/cases" class="nav-link">
            <span class="transition-box">work</span>
          </router-link>
          <!-- <router-link to="/about" class="nav-link"><span class="transition-box">about</span></router-link> -->
          <router-link to="/contact" class="nav-link">
            <span class="transition-box">contact</span>
          </router-link>
        </div>

        <!-- Mobile Menu -->
        <!-- <div class="menu-links__mobile" :class="[this.mobileMenuIsOpen ? 'open' : '']">
                <div class="menu-links__mobile__close">
                    <button type="button" name="button" @click="toggleMobileMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 371.23 371.23" style="enable-background:new 0 0 371.23 371.23;" xml:space="preserve" width="512px" height="512px">
                            <polygon points="371.23,21.213 350.018,0 185.615,164.402 21.213,0 0,21.213 164.402,185.615 0,350.018 21.213,371.23   185.615,206.828 350.018,371.23 371.23,350.018 206.828,185.615 " fill="#FFFFFF"/>
                        </svg>
                    </button>
                </div>
                <a @click.prevent="redirect('/works')" class="nav-link">
                    <span class="transition-box">
                        <p>work</p>
                    </span>
                </a>
                <a @click.prevent="redirect('/about')" class="nav-link">
                    <span class="transition-box">
                        <p>about</p>
                    </span>
                </a>
                <a @click.prevent="redirect('/contacts')" class="nav-link">
                    <span class="transition-box">
                        <p>contacts</p>
                    </span>
                </a>
        </div>-->
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MainMenu",
  data() {
    return {
      mobileMenuIsOpen: false,
      lastScroll: 0,
      timer: null
    };
  },
  computed: mapState({
    lightTheme: state => state.globals.lightTheme,
    lightBackground: state => state.globals.lightBackground,
    scroll: state => state.globals.currentScroll,
    hideMenu: state => state.globals.hiddenMenu,
    smallScreen: state => state.globals.smallScreen
  }),
  watch: {
    scroll() {
      this.senseScroll(this.scroll);
    }
  },
  methods: {
    // toggleMobileMenu() {
    // 	this.mobileMenuIsOpen = !this.mobileMenuIsOpen
    // 	if (this.mobileMenuIsOpen) {
    // 		this.$store.commit('openOverlay')
    // 	} else {
    // 		this.$store.commit('closeOverlay')
    // 	}
    // },
    redirect(to) {
      //
      // Reload on logo-click
      //
      if (this.$route.path === to) location.reload();
      //
      // How you like that, vue-community?
      //
      this.$router.push(to);
      this.mobileMenuIsOpen = false;
    },
    calculateUnderlayingbgColor() {
      /*
       * Returns the topmost visible rgb-color at a given point.
       * Works by inactivating one element at the time, and then resetting them
       * TODO: Include alpha channel check, for transparent colors
       * TODO: Include Image check https://github.com/kennethcachia/background-check
       * @param {number} x - The x-coordinate to check
       * @param {number} y - The y-coordinate to check
       * @returns {Number} - A number 0-1, 1 for white 0 for black
       */
      const visibleBgBrightness = (x, y) => {
        // arg: rgb(125,125,125)
        // returns: [125, 125, 125]
        const getColorValues = rgb =>
          rgb.substring(rgb.indexOf("(") + 1, rgb.length - 1).split(", ");

        // arg: [125, 125, 125]
        // returns: 0.5
        const getBrightness = rgbArr => {
          return (
            Math.sqrt(
              0.299 * Math.pow(parseInt(rgbArr[0]), 2) +
                0.587 * Math.pow(parseInt(rgbArr[1]), 2) +
                0.114 * Math.pow(parseInt(rgbArr[2]), 2)
            ) / 255 || 0
          );
        };

        const firstVisibleBgColor = (x, y) => {
          // some helper functions
          const getPointerEvent = el => el.style.pointerEvent || null;
          const getBgColor = el => window.getComputedStyle(el).backgroundColor;
          const inactivate = el =>
            Object.assign(el.style, {
              pointerEvents: "none"
            });
          const isDefault = rgb => rgb === "rgba(0, 0, 0, 0)";
          const isBody = el => el && el.nodeName === "BODY";

          // Used to resetting the store
          const reset = arr => {
            arr.map(el => {
              if (el.pointerEvent) {
                Object.assign(el.element.style, {
                  pointerEvents: el.pointerEvent
                });
              } else {
                el.element.style.removeProperty("pointer-events");
              }
            });
          };

          // returns first bg-color there is
          const recurseLoop = (
            x,
            y,
            lastEl,
            allEl = [],
            callStackBuffer = 100
          ) => {
            if (isBody(lastEl) || !callStackBuffer) {
              reset(allEl);
              return "rgb(255,255,255)";
            }

            const element = document.elementFromPoint(x, y);
            const pointerEvent = getPointerEvent(element);
            const bgColor = getBgColor(element);

            inactivate(element);

            allEl.push({
              element,
              pointerEvent
            });

            // Quick fix to not fuck everything up
            callStackBuffer--;

            if (isDefault(bgColor)) {
              return recurseLoop(x, y, element, allEl, callStackBuffer);
            } else {
              reset(allEl);
              return bgColor;
            }
          };

          return recurseLoop(x, y);
        };

        return getBrightness(getColorValues(firstVisibleBgColor(x, y)));
      };

      const logo = this.$el.firstChild.firstChild.firstChild;

      const logoMiddle = {
        x:
          logo.getBoundingClientRect().x +
          logo.getBoundingClientRect().width / 2,
        y:
          logo.getBoundingClientRect().y +
          logo.getBoundingClientRect().height / 2
      };

      const isLight =
        visibleBgBrightness(logoMiddle.x, logoMiddle.y) < 0.9 ? false : true;

      if (this.scroll > 100) {
        this.$store.commit("SET_LIGHT_BACKGROUND", isLight);
      } else this.$store.commit("SET_LIGHT_BACKGROUND", false);
    },
    senseScroll(newScroll) {
      // Hiding the menu on scroll
      const toggleMenu = () => {
        // If scroll is downwards, and we're more than 100px down
        const hiddenState =
          this.lastScroll < newScroll && newScroll > 100 ? true : false;

        this.$store.commit("SET_HIDDEN_MENU", hiddenState);
        this.lastScroll = newScroll;
      };

      this.calculateUnderlayingbgColor();
      toggleMenu();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../scss/globals.scss";

@keyframes introSlide {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes logoFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#nav {
  @include typeface(expanded);

  transition: color 0.5s $very-ease-out;
  display: flex;
  justify-content: space-between;
  align-items: center;

  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  // height: $menu-height-mobile;
  padding: $margin1-4 $margin1-8;
  box-sizing: border-box;

  line-height: 1;

  pointer-events: none;
  user-select: none;

  color: currentColor;

  overflow: hidden;

  &.light-bg {
    color: $color-black;
  }
  &.dark-bg {
    color: $color-white;
  }

  @media screen and (min-width: 440px) {
    padding: $margin1-4 $margin1-4 0;
  }
  @media screen and (min-width: 769px) {
    padding: $margin1-2 $margin1-2 0;
  }
  @media screen and (min-width: 1025px) {
    padding: $margin1-1 $margin1-1 0;
  }

  .transition-box {
    margin-top: -0.2em;
    position: relative;
  }

  a,
  button {
    @extend %hover-underline;
    pointer-events: all;

    &.logo {
      margin-top: 0.5em;

      svg {
        width: 110px;
        fill: currentColor;

        &.-small {
          width: 60px;
        }
      }

      &:after {
        display: none;
      }
    }

    &:visited {
      color: currentColor;
    }

    &.router-link-active {
      &:after {
        transform: scaleX(1);
      }
    }
  }

  .half {
    @include typeset(body-small);

    display: flex;
    overflow-y: hidden;

    .menu-links {
      a {
        span {
          transition: transform 0.3s $very-ease-out, opacity 0.3s $very-ease-out;
          display: inline-block;
        }

        &:nth-of-type(2) {
          span {
            transition-delay: 0.05s;
          }
        }

        &:nth-of-type(3) {
          span {
            transition-delay: 0.1s;
          }
        }
      }
    }

    &.hidden {
      * {
        pointer-events: none;
      }

      .menu-links {
        a {
          span {
            transform: translateY(-50%);
            opacity: 0;
          }
          &:after {
            transform-origin: right;
            transform: scaleX(0);
            transition-delay: 0.1s;
          }
          &:nth-of-type(2) {
            &:after {
              transition-delay: 0.15s;
            }
          }
          &:nth-of-type(3) {
            &:after {
              transition-delay: 0.2s;
            }
          }
        }
      }
    }
  }
}

.mobile-menu-toggle {
  background: none;
  color: currentColor;
  border: none;
  font-size: 1em;
  padding: 0;
  font-family: $font-expanded;
  outline: none;
  display: none;
  /*
     * Uncomment this to get the mobile menu working
     */
  // @media screen and (max-width: 377px) {
  //     display: block;
  // }
}

.menu-links {
  display: flex;
  /*
     * Uncomment this to get the mobile menu working
     */
  // @media screen and (max-width: 377px) {
  //     display: none;
  // }

  &__mobile {
    display: flex;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    flex-direction: column;
    justify-content: space-around;
    color: $color-white;
    z-index: 11;
    @media screen and (min-width: 377px) {
      display: none;
    }

    a {
      transition: transform 0.6s $very-ease-out;
      transform: translateX(100%);

      p {
        transition: transform 0.6s $very-ease-out;
        transform: translateY(100%);
      }

      &:nth-of-type(1) {
        background-color: $color-black;
        transition-delay: 0.1s;

        p {
          transition-delay: 0.7s;
        }
      }

      &:nth-of-type(2) {
        background-color: #222222;
        transition-delay: 0.2s;

        p {
          transition-delay: 0.8s;
        }
      }

      &:nth-of-type(3) {
        background-color: #2f2f2f;
        transition-delay: 0.3s;

        p {
          transition-delay: 0.9s;
        }
      }
    }

    &.open {
      a {
        transform: translateX(0);

        p {
          transform: translateY(0);
        }
      }
      .menu-links__mobile__close {
        opacity: 1;
      }
    }

    &__close {
      transition: opacity 0.6s $ease-in-out;
      opacity: 0;
      position: absolute;
      z-index: 10;
      display: flex;
      align-items: center;
      right: 0;
      top: 2px;
      width: 3em;
      height: $menu-height-mobile;

      button {
        border: none;
        background: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        margin: 0 0 -0.75em;
        padding: 0;
      }

      svg {
        width: $font-size-m;
        height: $font-size-m;
      }
    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      height: calc(100% / 3);
      font-size: 2.5em;
      &:last-of-type {
        border-bottom: none;
      }
      &.router-link-active,
      &:hover {
        -webkit-text-stroke: $link-outline $color-white !important;
      }
    }
  }
}

$menu-ani-dur: 0.8s;
$menu-ani-del: 0.2s;
$menu-ani-stg: 0.15s;

.nav-link {
  animation: introSlide #{$menu-ani-dur} #{$menu-ani-del} forwards
    cubic-bezier(0.215, 0.61, 0.355, 1);
  opacity: 0;
  transform: translateY(100%);
  font-size: 1em;
  margin: 0 0.5em;

  &:nth-of-type(2) {
    animation-delay: #{$menu-ani-del + $menu-ani-stg};
  }

  &:last-of-type {
    margin-right: 0;
  }
}

.logo {
  animation: logoFadeIn 0.6s forwards cubic-bezier(0.215, 0.61, 0.355, 1);
  opacity: 0;
  font-size: 1em;
  margin-left: 0;
  -webkit-text-stroke: 0 !important;
  color: currentColor !important;
  z-index: 10;
  cursor: pointer;

  &:hover {
    &:after {
      display: none;
    }
  }
}
</style>
